import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import ICONS from "../../../../assets/Icons";
import StatusContainer from "../../../../components/_utils/CommonStatus/StatusContainer";
import InfoCard from "../../../../components/_utils/CommonStatus/StatusSubComponents/StatusCardContainer/InfoCard";
import TabsWeapperSection from "../../../../components/_utils/CommonStatus/StatusSubComponents/TabsWrapperSection";
import { setHideBreadCrumb } from "../../../../redux/features/hideBreadCrumb/hideBreadCrumb";
import useCategories from "../../../../utils/useCategories";

function BulkTransactionSuccess() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const categoryMapper = useCategories();
  const [sucessdata, setsucessdata] = useState([]);

  const UploadStatement = () => {
    navigate("/beneficiary_transaction_dashboard/create_bulk_transaction");
  };

  const goTodashboard = () => {
    navigate("/beneficiary_transaction_dashboard");
  };

  const buttonRows = [
    [
      {
        btnText: "Create bulk transaction",
        enabledBgColor: "var(--text-primary)",
        enabledTextColor: "var(--positive-bg)",
        icon: ICONS?.ADD_BUTTON,
        handleFunction: UploadStatement,
        iconToBeAlign: "left",
        fullWidthRequired: true,
        imgColor: "var(--positive-bg)",
      },
    ],
    [
      {
        btnText: "Go to dashboard",
        enabledBgColor: "var(--bg-positive-bg)",
        enabledTextColor: "var(--text-primary)",
        icon: ICONS.DASHBOARD,
        handleFunction: goTodashboard,
        iconToBeAlign: "left",
        fullWidthRequired: true,
        outLineColor: "var(--text-primary)",
        hoverOption: "dark",
      },
    ],
  ];

  useEffect(() => {
    dispatch(setHideBreadCrumb({ hide: true }));

    return () => {
      dispatch(setHideBreadCrumb({ hide: false }));
    };
  }, [dispatch]);

  useEffect(() => {
    const data = sessionStorage.getItem("uploadTxnStatementData");
    setsucessdata(JSON.parse(data));
  }, []);

  return (
    <div>
      <StatusContainer
        status="success"
        buttonRows={buttonRows}
        title="File has been uploaded successfully and transactions are being processed."
        subtitle="Once the transactions are processed, you will be notified by email."
      >
        <TabsWeapperSection title="Upload details">
          <>
            <InfoCard
              bgColor="var(--positive-card)"
              rows={[
                {
                  leftTitle: sucessdata?.category,
                  leftSubTitle: "Transaction category",
                  icon: categoryMapper(sucessdata.category),
                },
              ]}
            />

            <InfoCard
              bgColor="var(--positive-card)"
              rows={[
                {
                  leftTitle: sucessdata?.uploaded_file_data?.metadata?.filename,
                  leftSubTitle: "File name",
                },
              ]}
            />
          </>
        </TabsWeapperSection>
      </StatusContainer>
    </div>
  );
}

export default BulkTransactionSuccess;
